module.exports = __webpack_public_path__ + "static/img/3063_phase_function_Paper_Points.2c7c3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3063_phase_function_Paper_Points.png
// module id = rlSg
// module chunks = 0